import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Ensure the client requests JSON explicitly to avoid PostgREST 406 responses
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
	auth: {
		autoRefreshToken: true,
		persistSession: true,
		detectSessionInUrl: true,
	},
	global: {
		headers: {
			Accept: 'application/json'
		}
	}
});

// Expose client on window in non-production for quick console testing
if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  // attach for debugging only
  // eslint-disable-next-line no-undef
  window.supabase = supabase;
}